import { Injectable } from '@angular/core';

import { reduce } from 'lodash-es';
import * as pixelWidth from 'string-pixel-width';

@Injectable()
export class UtilsService {
  private ctx: CanvasRenderingContext2D;

  constructor() {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    if (!ctx) {
      throw new Error('Unable to get 2D context from canvas');
    }
    this.ctx = ctx;
  }

  // text width is being measured by 2 different methods, max score is being returned
  public measureText(txt = '', fontSize: number, fontFamily = 'Segoe UI'): number {
    this.ctx.font = `${fontSize}px ${fontFamily}`;
    const maxInput = reduce(txt.split('<br>'), (a, b) => (a.toString().length > b.toString().length ? a : b));

    return Math.ceil(this.ctx.measureText(maxInput).width ?? pixelWidth(maxInput, { size: fontSize, font: 'open sans' }));
  }
}
